import { $t } from "@/locales";
const errorCodeMap = {
  12030001: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  12030002: () => $t(`errorCode['Operation failed!']`),
  12030003: () =>
    $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['identity information! Please login again']`)]),
  12020002: () => $t(`errorCode['parameter error']`),
  12040001: () => $t(`errorCode['Operation failed!']`),
  12040016: () =>
    $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['identity information! Please login again']`)]),
  12040017: () => $t(`errorCode['']`),
  12040018: () => $t(`errorCode['']`),
  12050001: () => $t(`errorCode['parameter error']`),
  12050004: () => $t(`errorCode['community name already exist']`),
  12010001: () => $t(`errorCode['Operation failed!']`),
  12011000: () => $t(`errorCode['Email is required.']`),
  12011003: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  12011004: () => $t(`errorCode['Mobile number is required.']`),
  12011005: () => $t(`errorCode['Operation failed!']`),
  12011006: () => $t(`errorCode['Operation failed!']`),
  12011007: () => $t(`errorCode['Operation failed!']`),
  12011008: () => $t(`errorCode['Operation failed!']`),
  12011010: () => $t(`errorCode['Operation failed!']`),
  12011011: () => $t(`errorCode['Operation failed!']`),
  12011012: () => $t(`errorCode["This Email doesn\'t exist."]`),
  12011013: () =>
    $t(`errorCode['Your account is not activated, please contact your service provider.']`),
  12011014: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Code']`)]),
  12011015: () => $t(`errorCode['You are trying too often, please try again in 5 minutes.']`),
  12000001: () => $t(`errorCode['Operation failed!']`),
  12001001: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  12001002: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  12001003: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['emergency action type']`)]),
  12001004: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  12001005: () => $t(`errorCode['Operation failed!']`),
  12001006: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  12001007: () => $t(`errorCode['Operation failed!']`),
  12001008: () => $t(`errorCode['Operation failed!']`),
  12001009: () => $t(`errorCode['Operation failed!']`),
  12001016: () => $t(`errorCode['Only 1000 data items can be imported at a time.']`),
  12001017: () => $t(`errorCode['Operation failed!']`),
  12001018: () => $t(`errorCode['File Check Failed']`),
  12001019: () => $t(`errorCode['File Check Failed']`),
  12001020: () => $t(`errorCode['File Check Failed']`),
  12001021: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  12001022: () => $t(`errorCode["You can\'t make payments for offices in different time zones."]`),
  12001023: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  12001024: () => $t(`errorCode['Operation failed!']`),
  12001025: () => $t(`errorCode['Operation failed!']`),
  12001026: () =>
    $t(`errorCode['Please ensure that all doors in the project are activated at the same time.']`),
  12001027: () => $t(`errorCode['Operation failed!']`),
  12001029: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  12001030: () =>
    $t(`errorCode['Please ensure that all doors in the project are renewed at the same time.']`),
  12001031: () => $t(`errorCode['The current scheduling staff exceeds 200 people.']`),
  12001033: () =>
    $t(
      `errorCode['The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.']`
    ),
  12001034: () =>
    $t(
      `errorCode['The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.']`
    ),
  12001037: () =>
    $t(`errorCode['Invalid {0}.']`, [
      $t(`errorCode['personnel app without intercom feature number']`)
    ]),
  12001038: () => $t(`errorCode['Operation failed!']`),
  12060002: () => $t(`errorCode['Operation failed!']`),
  12060003: () =>
    $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['identity information! Please login again']`)]),
  12061001: () => $t(`errorCode['Operation failed!']`),
  12061002: () => $t(`errorCode['Operation failed!']`),
  13021025: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Face']`)]),
  13021029: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Time']`)]),
  13031005: () => $t(`errorCode['']`),
  13031006: () => $t(`errorCode['']`),
  13031007: () => $t(`errorCode['']`),
  13031012: () => $t(`errorCode['']`),
  13031015: () => $t(`errorCode['check feature billing charge plan new error']`),
  13031016: () => $t(`errorCode['subscription not found']`),
  13031018: () => $t(`errorCode['community not found']`),
  13001002: () => $t(`errorCode['']`),
  13001004: () => $t(`errorCode['Operation failed!']`),
  13001005: () => $t(`errorCode['Operation failed!']`),
  13001006: () => $t(`errorCode['Operation failed!']`),
  13001007: () => $t(`errorCode['Operation failed!']`),
  13001008: () => $t(`errorCode['Operation failed!']`),
  13001009: () => $t(`errorCode['Operation failed!']`),
  13001010: () => $t(`errorCode['Failed to get data.']`),
  13001011: () => $t(`errorCode['Operation failed!']`),
  13001012: () => $t(`errorCode['Failed to get data.']`),
  13001013: () => $t(`errorCode['Operation failed!']`),
  13001014: () => $t(`errorCode['Operation failed!']`),
  13001015: () => $t(`errorCode['Operation failed!']`),
  13001016: () => $t(`errorCode['Failed to get data.']`),
  13001017: () => $t(`errorCode['Failed to get data.']`),
  13001018: () => $t(`errorCode['Failed to get data.']`),
  13001019: () => $t(`errorCode['Failed to get data.']`),
  13001020: () => $t(`errorCode['Failed to get data.']`),
  13001021: () => $t(`errorCode['Operation failed!']`),
  13001022: () => $t(`errorCode['Operation failed!']`),
  13001023: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['param']`)]),
  13001024: () => $t(`errorCode['Operation failed!']`),
  13001025: () => $t(`errorCode['Operation failed!']`),
  13001026: () => $t(`errorCode['Operation failed!']`),
  13001028: () => $t(`errorCode['Failed to get data.']`),
  13001029: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Email']`)]),
  13051101: () => $t(`errorCode['Invalid UserName or Password']`),
  13051102: () => $t(`errorCode['Operation failed!']`),
  13051103: () => $t(`errorCode['Operation failed!']`),
  13051104: () => $t(`errorCode['Operation failed!']`),
  13051105: () => $t(`errorCode['Operation failed!']`),
  13051106: () => $t(`errorCode['Operation failed!']`),
  13051107: () => $t(`errorCode['Operation failed!']`),
  13051108: () => $t(`errorCode['Operation failed!']`),
  13051109: () => $t(`errorCode['Operation failed!']`),
  13051110: () => $t(`errorCode['Operation failed!']`),
  13051111: () => $t(`errorCode['Operation failed!']`),
  13051112: () => $t(`errorCode['Operation failed!']`),
  13051113: () => $t(`errorCode['Operation failed!']`),
  13051114: () => $t(`errorCode['Operation failed!']`),
  13051115: () => $t(`errorCode['Operation failed!']`),
  13051116: () => $t(`errorCode['Operation failed!']`),
  13051117: () => $t(`errorCode['Operation failed!']`),
  13051118: () => $t(`errorCode['Operation failed!']`),
  13051119: () => $t(`errorCode['Operation failed!']`),
  13051120: () => $t(`errorCode['Operation failed!']`),
  13051121: () => $t(`errorCode['Operation failed!']`),
  13051122: () => $t(`errorCode['Operation failed!']`),
  13051123: () => $t(`errorCode['Operation failed!']`),
  13051124: () => $t(`errorCode['Operation failed!']`),
  13051125: () => $t(`errorCode['Operation failed!']`),
  13051126: () => $t(`errorCode['Operation failed!']`),
  13051127: () => $t(`errorCode['Operation failed!']`),
  13051129: () => $t(`errorCode['Operation failed!']`),
  13051130: () => $t(`errorCode['Operation failed!']`),
  13051131: () => $t(`errorCode['Operation failed!']`),
  13051132: () => $t(`errorCode['Operation failed!']`),
  13051133: () => $t(`errorCode['Operation failed!']`),
  13051134: () => $t(`errorCode['Operation failed!']`),
  13051135: () => $t(`errorCode['Operation failed!']`),
  13051136: () => $t(`errorCode['Operation failed!']`),
  13051137: () => $t(`errorCode['Failed to get data.']`),
  13051138: () => $t(`errorCode['Failed to get data.']`),
  13051139: () => $t(`errorCode['Failed to get data.']`),
  13051141: () => $t(`errorCode['Failed to get data.']`),
  13051142: () => $t(`errorCode['Failed to get data.']`),
  13041101: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Login Account']`)]),
  13041102: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Code']`)]),
  13041103: () => $t(`errorCode['Operation failed!']`),
  13041104: () => $t(`errorCode['Operation failed!']`),
  13041105: () => $t(`errorCode['Operation failed!']`),
  13041106: () => $t(`errorCode['Operation failed!']`),
  13041107: () => $t(`errorCode['Operation failed!']`),
  13041108: () => $t(`errorCode['Operation failed!']`),
  13041109: () => $t(`errorCode['Operation failed!']`),
  13041110: () => $t(`errorCode['Operation failed!']`),
  13041111: () => $t(`errorCode['Salto Token Expired.']`),
  13041112: () => $t(`errorCode['Operation failed!']`),
  13041113: () => $t(`errorCode['Operation failed!']`),
  13041114: () => $t(`errorCode['Operation failed!']`),
  13041115: () => $t(`errorCode['Operation failed!']`),
  13041116: () => $t(`errorCode['Too many failed attempts, please try again in a few minutes.']`),
  13041117: () => $t(`errorCode['Salto Token Expired.']`),
  13041118: () => $t(`errorCode['Operation failed!']`),
  13041119: () => $t(`errorCode['Salto Account Blocked.']`),
  13041120: () => $t(`errorCode['Remote open not in access group.']`),
  13041121: () => $t(`errorCode['IQ Offline.']`),
  13041122: () => $t(`errorCode['Operation failed!']`),
  13041123: () => $t(`errorCode['Operation failed!']`),
  13041124: () =>
    $t(`errorCode["Your Salto KS account does not have permission to modify the lock\'s name."]`),
  13041125: () => $t(`errorCode['Operation failed!']`),
  13070005: () => $t(`errorCode['System setting record not found.']`),
  13070011: () => $t(`errorCode['Smart home not enabled.']`),
  13061101: () => $t(`errorCode['Operation failed!']`),
  13061102: () => $t(`errorCode['Invalid Username or Password']`),
  13061103: () => $t(`errorCode['Operation failed!']`),
  13061104: () => $t(`errorCode['Operation failed!']`),
  13061105: () => $t(`errorCode['Operation failed!']`),
  13061106: () => $t(`errorCode['Operation failed!']`),
  13061107: () => $t(`errorCode['Operation failed!']`),
  13061108: () => $t(`errorCode['Operation failed!']`),
  13061109: () => $t(`errorCode['Operation failed!']`),
  13061110: () => $t(`errorCode['Operation failed!']`),
  13061111: () => $t(`errorCode['Operation failed!']`),
  13061112: () => $t(`errorCode['Operation failed!']`),
  13061113: () => $t(`errorCode['Operation failed!']`),
  11131002: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['PIN']`)]),
  11131003: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['RF Card']`)]),
  11131004: () => $t(`errorCode['Owner is required.']`),
  11131005: () => $t(`errorCode['Operation failed!']`),
  11131006: () => $t(`errorCode['Office is required.']`),
  11131010: () => $t(`errorCode['Operation failed!']`),
  11131011: () => $t(`errorCode['Operation failed!']`),
  11131012: () => $t(`errorCode['PIN or RF Card is required.']`),
  11131013: () => $t(`errorCode['Operation failed!']`),
  11131014: () => $t(`errorCode['Operation failed!']`),
  11131015: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['PIN']`)]),
  11131016: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['RF card']`)]),
  11131019: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11131020: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11131021: () => $t(`errorCode['Personnel is required.']`),
  11131022: () =>
    $t(`errorCode['The data has been updated. Please refresh the page and try again.']`),
  11131023: () => $t(`errorCode['Operation failed!']`),
  11131024: () =>
    $t(`errorCode['The data has been updated. Please refresh the page and try again.']`),
  11131028: () => $t(`errorCode['Operation failed!']`),
  11131029: () => $t(`errorCode['Operation failed!']`),
  11131030: () => $t(`errorCode['Operation failed!']`),
  11131031: () => $t(`errorCode['Operation failed!']`),
  11131032: () => $t(`errorCode['Failed to add. This user already has 5 license plates.']`),
  11131033: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['License Plate']`)]),
  11131035: () => $t(`errorCode['Operation failed!']`),
  11131036: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['UHF Card']`)]),
  11131038: () => $t(`errorCode['Operation failed!']`),
  11131039: () => $t(`errorCode['Operation failed!']`),
  11131040: () => $t(`errorCode['Operation failed!']`),
  11131041: () => $t(`errorCode['Operation failed!']`),
  11131042: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['License Plate']`)]),
  11131044: () => $t(`errorCode['fingerprint code must be equal 1620 characters or empty.']`),
  11131045: () => $t(`errorCode['Personnel not in office.']`),
  11310002: () => $t(`errorCode['']`),
  11310003: () => $t(`errorCode['']`),
  11310004: () => $t(`errorCode['']`),
  11310005: () => $t(`errorCode['']`),
  11310006: () => $t(`errorCode['']`),
  11310007: () => $t(`errorCode['']`),
  11310008: () => $t(`errorCode['']`),
  11310009: () => $t(`errorCode['']`),
  11310010: () => $t(`errorCode['']`),
  11310011: () => $t(`errorCode['']`),
  11001010: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['email address']`)]),
  11001012: () => $t(`errorCode['Failed to get data.']`),
  11001013: () =>
    $t(`errorCode['The data has been updated. Please refresh the page and try again.']`),
  11001014: () => $t(`errorCode['Operation failed!']`),
  11001015: () => $t(`errorCode['Operation failed!']`),
  11001018: () => $t(`errorCode['User name too long.']`),
  11001019: () => $t(`errorCode['Operation failed!']`),
  11001020: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['name']`)]),
  11001021: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['mobile number']`)]),
  11001022: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['mobile number']`)]),
  11001023: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['mobile number']`)]),
  11001024: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['mobile number']`)]),
  11001025: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['MAC']`)]),
  11001026: () => $t(`errorCode['Operation failed!']`),
  11001027: () => $t(`errorCode['Operation failed!']`),
  11001028: () => $t(`errorCode['Operation failed!']`),
  11001029: () => $t(`errorCode['Operation failed!']`),
  11001030: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['network group']`)]),
  11001031: () => $t(`errorCode['Operation failed!']`),
  11001032: () => $t(`errorCode['Operation failed!']`),
  11001033: () => $t(`errorCode['Operation failed!']`),
  11001034: () => $t(`errorCode['AutoP length must be less 2048 bytes.']`),
  11001035: () => $t(`errorCode['Operation failed!']`),
  11001036: () => $t(`errorCode['Operation failed!']`),
  11001037: () => $t(`errorCode['Operation failed!']`),
  11001038: () => $t(`errorCode['Operation failed!']`),
  11001039: () => $t(`errorCode['Operation failed!']`),
  11001040: () => $t(`errorCode['Operation failed!']`),
  11001041: () => $t(`errorCode['Operation failed!']`),
  11001042: () => $t(`errorCode['Operation failed!']`),
  11001045: () => $t(`errorCode['Password is too weak.']`),
  11001046: () => $t(`errorCode['Operation failed!']`),
  11001047: () => $t(`errorCode['Operation failed!']`),
  11001048: () => $t(`errorCode['Operation failed!']`),
  11001049: () => $t(`errorCode['Operation failed!']`),
  11001050: () => $t(`errorCode['Operation failed!']`),
  11001051: () => $t(`errorCode['Operation failed!']`),
  11001052: () => $t(`errorCode['Operation failed!']`),
  11001055: () => $t(`errorCode['The password is too short.']`),
  11001056: () => $t(`errorCode['Operation failed!']`),
  11001057: () => $t(`errorCode['']`),
  11001058: () => $t(`errorCode['']`),
  11001059: () => $t(`errorCode['']`),
  11001060: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['param']`)]),
  11001061: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['param']`)]),
  11001062: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['param']`)]),
  11001063: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['param']`)]),
  11001064: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['param']`)]),
  11001065: () => $t(`errorCode['']`),
  11001066: () => $t(`errorCode['']`),
  11001067: () => $t(`errorCode['']`),
  11001068: () => $t(`errorCode['']`),
  11001069: () => $t(`errorCode['']`),
  11001070: () => $t(`errorCode['']`),
  11001071: () => $t(`errorCode['']`),
  11001072: () => $t(`errorCode['']`),
  11001073: () => $t(`errorCode['']`),
  11001074: () => $t(`errorCode['']`),
  11001075: () => $t(`errorCode['']`),
  11001076: () => $t(`errorCode['']`),
  11001077: () => $t(`errorCode['']`),
  11001078: () => $t(`errorCode['Operation failed!']`),
  11001079: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['param']`)]),
  11001080: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['param']`)]),
  11001081: () => $t(`errorCode['']`),
  11001082: () => $t(`errorCode['']`),
  11001085: () => $t(`errorCode['smart lock type error.']`),
  11001086: () => $t(`errorCode['smart lock type error.']`),
  11001087: () => $t(`errorCode['the apt call type value is invalid.']`),
  11001088: () => $t(`errorCode['the ip call or sip call value is invalid.']`),
  11001089: () => $t(`errorCode['php web server error']`),
  11451004: () =>
    $t(
      `errorCode['pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.']`
    ),
  11451005: () => $t(`errorCode['rfCard must be A-F0-9 and less than 16 bits or empty.']`),
  11451006: () => $t(`errorCode['owner cannot be empty.']`),
  11451007: () => $t(`errorCode['creator cannot be empty.']`),
  11451008: () => $t(`errorCode['the creator type value is invalid']`),
  11451009: () => $t(`errorCode['the IsCreateByPm value is invalid']`),
  11451010: () => $t(`errorCode['the pinCode already exist']`),
  11451011: () => $t(`errorCode['the rfCard already exist']`),
  11451012: () => $t(`errorCode['license plate is invalid.']`),
  11451013: () => $t(`errorCode['owner info is invalid.']`),
  11451014: () => $t(`errorCode['uhf is invalid.']`),
  11451015: () => $t(`errorCode['time control is invalid.']`),
  11451016: () =>
    $t(
      `errorCode['You have reached the limit of 5 Vehicle License Plate and are not allowed to add']`
    ),
  11451017: () => $t(`errorCode['the plate already exist']`),
  11451018: () => $t(`errorCode['the uhf already exist']`),
  11451019: () => $t(`errorCode['empty community']`),
  11451020: () => $t(`errorCode['no find license Plate']`),
  11451021: () => $t(`errorCode['fingerprint code must be less than 2048 characters or empty.']`),
  11451022: () => $t(`errorCode['IDAccess mode must be 0, 1, or 2.']`),
  11451023: () => $t(`errorCode['Run field is required when mode is 1 or 2.']`),
  11451024: () => $t(`errorCode['Serial field is required when mode is 2.']`),
  11451025: () => $t(`errorCode['the pin cannot be empty']`),
  11451026: () => $t(`errorCode['the rfCard cannot be empty']`),
  11451027: () => $t(`errorCode['the IDAccess already exist']`),
  11451028: () => $t(`errorCode['the resident cannot be empty']`),
  11451029: () => $t(`errorCode['the fingerprint cannot be empty']`),
  11451030: () => $t(`errorCode['the face cannot be empty']`),
  11451031: () => $t(`errorCode['not found pin']`),
  11451032: () => $t(`errorCode['not found rfCard']`),
  11451033: () => $t(`errorCode['not found IDAccess']`),
  11451034: () => $t(`errorCode['not found fingerprint']`),
  11451035: () => $t(`errorCode['not found face']`),
  11451036: () => $t(`errorCode['face pic is invalid.']`),
  11451037: () => $t(`errorCode['community build and room cannot be empty.']`),
  11451038: () => $t(`errorCode['device info mac cannot be empty.']`),
  11451039: () =>
    $t(
      `errorCode['scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.']`
    ),
  11451040: () => $t(`errorCode['MAC address cannot be empty.']`),
  11451041: () => $t(`errorCode['MAC address 0C1105000000 is not allowed.']`),
  11451042: () => $t(`errorCode['MAC address must be 12 hexadecimal characters.']`),
  11451043: () => $t(`errorCode['Scheduler type value is invalid.']`),
  11451044: () => $t(`errorCode['parse is fail']`),
  11451045: () => $t(`errorCode['the fingerprint already exist']`),
  11451046: () => $t(`errorCode['the licensePlate cannot be empty']`),
  11451047: () => $t(`errorCode['the licensePlate already exist']`),
  11451048: () => $t(`errorCode['idaccess run must be 10 digit number or end with -K.']`),
  11451049: () => $t(`errorCode['idaccess serial must be 9 digit number.']`),
  11451050: () => $t(`errorCode['relay not in 0-15']`),
  11451051: () => $t(`errorCode['security relay not in 0-3']`),
  11451052: () => $t(`errorCode['file name is wrong']`),
  11451053: () => $t(`errorCode['The PersonalAccount is not active.']`),
  11451054: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['access mode specified']`)]),
  11451055: () => $t(`errorCode['create community user accessmode failed.']`),
  11451056: () => $t(`errorCode['delete community user accessmode failed.']`),
  11340002: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['ground floor type']`)]),
  11340003: () =>
    $t(`errorCode['Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.']`),
  11340004: () => $t(`errorCode['Building ID must be between 1 and 99.']`),
  11340005: () =>
    $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Community building name']`)]),
  11340006: () => $t(`errorCode['Building ID already exists in this community.']`),
  11340007: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['building ID']`)]),
  11340009: () => $t(`errorCode['Cannot delete building because it has associated devices.']`),
  11340010: () => $t(`errorCode['Cannot delete building because it has associated users.']`),
  11340011: () =>
    $t(`errorCode['Cannot delete building because it has associated salto devices.']`),
  11340012: () => $t(`errorCode['Cannot delete building because it has associated iTec devices.']`),
  11340013: () =>
    $t(`errorCode['Cannot delete building because it has associated dormakaba devices.']`),
  11341003: () => $t(`errorCode['Community building not found.']`),
  11350002: () => $t(`errorCode['Invalid Name Display']`),
  11350003: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['mobilePhone']`)]),
  11350004: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['motionTime']`)]),
  11350005: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['motionType']`)]),
  11350006: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['postalCode']`)]),
  11350007: () => $t(`errorCode['The Community does not exist.']`),
  11350009: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Community name']`)]),
  11350010: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11350011: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11350013: () => $t(`errorCode['Update CommunityIsInstallerKit Error.']`),
  11350014: () => $t(`errorCode['Dis Not SupportCommunityCalls Error.']`),
  11350015: () => $t(`errorCode['Community Has Special Device, Not Allowed To Delete.']`),
  11350016: () => $t(`errorCode['The project smart home switch must be disabled']`),
  11350017: () => $t(`errorCode['There are ITec Locks in project']`),
  11350018: () => $t(`errorCode['There are Salto Locks in project']`),
  11350019: () => $t(`errorCode['There are Dormakaba Locks in project']`),
  11350020: () => $t(`errorCode['It is rent manager project']`),
  11350021: () => $t(`errorCode['It is installer account']`),
  11350022: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11350023: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['member limit num']`)]),
  11350024: () => $t(`errorCode['Indoor Monitor No Set Error.']`),
  11370002: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['floor format']`)]),
  11370003: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['contact preference type']`)]),
  11370004: () => $t(`errorCode['Floor list is required when not all floors.']`),
  11370005: () => $t(`errorCode['Building floors list is required when all buildings.']`),
  11370006: () => $t(`errorCode['Indoor monitor name is required.']`),
  11370007: () => $t(`errorCode['The primary account is not activated.']`),
  11370008: () => $t(`errorCode["You can\'t create more family member accounts."]`),
  11370013: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['time format']`)]),
  11370015: () => $t(`errorCode['community user not found']`),
  11370016: () => $t(`errorCode['community is empty']`),
  11370017: () => $t(`errorCode['the end user not found']`),
  11370018: () => $t(`errorCode['the end user not master user']`),
  11370019: () => $t(`errorCode['the end user not member user']`),
  11370021: () => $t(`errorCode['The email already exists and cannot be repeated']`),
  11370022: () => $t(`errorCode['The mobile Number already exists']`),
  11370023: () => $t(`errorCode['The room number format error.']`),
  11420003: () => $t(`errorCode['community not found']`),
  11420004: () => $t(`errorCode['resident not found']`),
  11420005: () => $t(`errorCode['installer not found']`),
  11011003: () => $t(`errorCode['The length must be less than 32 characters.']`),
  11011004: () => $t(`errorCode['The length must be less than 32 characters.']`),
  11011005: () => $t(`errorCode['The length must be less than 32 characters.']`),
  11011006: () => $t(`errorCode['Operation failed!']`),
  11011007: () => $t(`errorCode['The length must be less than 256 characters.']`),
  11011008: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Email']`)]),
  11011009: () => $t(`errorCode['Operation failed!']`),
  11011010: () => $t(`errorCode['Operation failed!']`),
  11011011: () => $t(`errorCode['Operation failed!']`),
  11011012: () => $t(`errorCode['Operation failed!']`),
  11011013: () => $t(`errorCode['Operation failed!']`),
  11011015: () => $t(`errorCode['Operation failed!']`),
  11011016: () => $t(`errorCode['Operation failed!']`),
  11011017: () => $t(`errorCode['Operation failed!']`),
  11011018: () => $t(`errorCode['Operation failed!']`),
  11011024: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['date']`)]),
  11011025: () => $t(`errorCode['Operation failed!']`),
  11011026: () => $t(`errorCode['Operation failed!']`),
  11011027: () => $t(`errorCode['Operation failed!']`),
  11011029: () => $t(`errorCode['Failed to get data.']`),
  11011030: () => $t(`errorCode['Operation failed!']`),
  11011031: () => $t(`errorCode['Operation failed!']`),
  11011032: () => $t(`errorCode['Operation failed!']`),
  11011033: () => $t(`errorCode['Operation failed!']`),
  11011034: () => $t(`errorCode['Operation failed!']`),
  11011035: () => $t(`errorCode['Operation failed!']`),
  11011036: () => $t(`errorCode['']`),
  11011037: () => $t(`errorCode['Operation failed!']`),
  11011038: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11261001: () => $t(`errorCode['Lock name length must be between 1 and 50']`),
  11261002: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11261004: () => $t(`errorCode['The account has been added by another user.']`),
  11261005: () => $t(`errorCode['Operation failed!']`),
  11261006: () => $t(`errorCode['Operation failed!']`),
  11261007: () => $t(`errorCode['Operation failed!']`),
  11261008: () => $t(`errorCode['Failed to get data.']`),
  11261009: () => $t(`errorCode['Failed to get data.']`),
  11261010: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11261011: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11261012: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11261013: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11261014: () => $t(`errorCode['Failed to get data.']`),
  11261015: () => $t(`errorCode['Failed to get data.']`),
  11261017: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11261018: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11261019: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11261021: () => $t(`errorCode['Failed to get data.']`),
  11261022: () => $t(`errorCode['Operation failed!']`),
  11261023: () => $t(`errorCode['Operation failed!']`),
  11261025: () => $t(`errorCode['Operation failed!']`),
  11261026: () => $t(`errorCode['Operation failed!']`),
  11261027: () => $t(`errorCode['Operation failed!']`),
  11261028: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11261029: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Building']`)]),
  11261030: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['APT']`)]),
  11261031: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Owner']`)]),
  11261032: () => $t(`errorCode['Operation Failed!']`),
  11250003: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11250004: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11250006: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11250007: () => $t(`errorCode['No log to be exported.']`),
  11250008: () => $t(`errorCode['Time format is invalid.']`),
  11250009: () =>
    $t(`errorCode['Too large data! Please first export the data before %s first,thanks.']`),
  11250010: () => $t(`errorCode['No permission to export logs of this type.']`),
  11250011: () => $t(`errorCode['Project type is invalid.']`),
  11250015: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['detection type']`)]),
  11250016: () => $t(`errorCode['Data not exist.']`),
  11250025: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['log id']`)]),
  11251007: () => $t(`errorCode["You don\'t have operate permission"]`),
  11191005: () => $t(`errorCode['MAC address not in the MAC library.']`),
  11191006: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['MAC']`)]),
  11191007: () => $t(`errorCode['MAC address not in the MAC library.']`),
  11191008: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['MAC']`)]),
  11191009: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['MAC']`)]),
  11191010: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['MAC']`)]),
  11191011: () => $t(`errorCode['MAC address not in the MAC library.']`),
  11191012: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['MAC']`)]),
  11191013: () => $t(`errorCode['This MAC address is redirected on RPS.']`),
  11191014: () => $t(`errorCode['Operation failed!']`),
  11141002: () => $t(`errorCode['Operation failed!']`),
  11141003: () => $t(`errorCode['Operation failed!']`),
  11141004: () => $t(`errorCode['Operation failed!']`),
  11141005: () => $t(`errorCode['Operation failed!']`),
  11141006: () => $t(`errorCode['Operation failed!']`),
  11141007: () => $t(`errorCode['Operation failed!']`),
  11141008: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11141009: () => $t(`errorCode['Access Group is required.']`),
  11141011: () => $t(`errorCode['Operation failed!']`),
  11141012: () => $t(`errorCode['Office is required.']`),
  11141014: () => $t(`errorCode['Operation failed!']`),
  11141015: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11141017: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11141018: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11141020: () => $t(`errorCode['Company is required.']`),
  11141021: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11141022: () => $t(`errorCode['Device is required.']`),
  11141023: () => $t(`errorCode['Operation failed!']`),
  11101001: () => $t(`errorCode['Operation failed!']`),
  11101002: () => $t(`errorCode['Failed to get data.']`),
  11101004: () => $t(`errorCode['Company is required.']`),
  11101005: () => $t(`errorCode['Admin is required.']`),
  11101006: () => $t(`errorCode['Failed to get data.']`),
  11101007: () => $t(`errorCode['Operation failed!']`),
  11101008: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Email']`)]),
  11101009: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Mobile number']`)]),
  11101010: () => $t(`errorCode['Password Incorrect.']`),
  11101011: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Group']`)]),
  11101012: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Call Type']`)]),
  11101013: () => $t(`errorCode['Operation failed!']`),
  11101014: () => $t(`errorCode['Operation failed!']`),
  11101015: () => $t(`errorCode['Operation failed!']`),
  11101016: () => $t(`errorCode["Mobile Number doesn\'t exist."]`),
  11101017: () => $t(`errorCode["This Email doesn\'t exist."]`),
  11181010: () => $t(`errorCode['Operation failed!']`),
  11181011: () => $t(`errorCode['Operation failed!']`),
  11181012: () => $t(`errorCode['Operation failed!']`),
  11181013: () => $t(`errorCode['Failed to get data.']`),
  11181014: () => $t(`errorCode['Failed to get data.']`),
  11181015: () => $t(`errorCode['Operation failed!']`),
  11181016: () => $t(`errorCode['Operation failed!']`),
  11181017: () => $t(`errorCode['Operation failed!']`),
  11181018: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11181019: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11181020: () => $t(`errorCode['Operation failed!']`),
  11181021: () => $t(`errorCode['Failed to get data.']`),
  11181022: () => $t(`errorCode['Operation failed!']`),
  11181023: () => $t(`errorCode['Operation failed!']`),
  11181024: () => $t(`errorCode['Operation failed!']`),
  11181025: () => $t(`errorCode['Operation failed!']`),
  11181026: () => $t(`errorCode['Operation failed!']`),
  11231002: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['minutes']`)]),
  11231003: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['day']`)]),
  11231004: () => $t(`errorCode['Operation failed!']`),
  11231005: () => $t(`errorCode['Operation failed!']`),
  11231006: () => $t(`errorCode['Operation failed!']`),
  11231007: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['schedules']`)]),
  11231008: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Timetable name']`)]),
  11231009: () => $t(`errorCode['Deleting failed. The timetable is used by a shift.']`),
  11231010: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Shift name']`)]),
  11231011: () => $t(`errorCode['Deleting failed. The shift is in use.']`),
  11231012: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Company']`)]),
  11231013: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Date Time']`)]),
  11231014: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['time format']`)]),
  11231015: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11231017: () => $t(`errorCode['Valid time conflicts with an existing schedule.']`),
  11231018: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['relay']`)]),
  11231019: () => $t(`errorCode['The timing for multiple schedules must not coincide.']`),
  11231020: () =>
    $t(
      `errorCode['The start time of the valid check time cannot be later than the start work time.']`
    ),
  11231021: () =>
    $t(
      `errorCode['The end time of the valid check time cannot be earlier than the end work time.']`
    ),
  11231022: () => $t(`errorCode['Operation failed!']`),
  11231023: () => $t(`errorCode['Deleting failed. The leave type is in use.']`),
  11231024: () => $t(`errorCode['Operation failed!']`),
  11231025: () =>
    $t(`errorCode['The start time of the break time cannot be earlier than the start work time.']`),
  11231026: () =>
    $t(`errorCode['The end time of the break time cannot be later than the end work time.']`),
  11231027: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Time']`)]),
  11231028: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Time']`)]),
  11231029: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Attendance Log']`)]),
  11231030: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11231031: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11231033: () =>
    $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Attendance Point Name']`)]),
  11231034: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Leave type']`)]),
  11231035: () => $t(`errorCode['Operation failed!']`),
  11231036: () => $t(`errorCode['Operation failed!']`),
  11231037: () => $t(`errorCode['Operation failed!']`),
  11231038: () => $t(`errorCode['Operation failed!']`),
  11231039: () => $t(`errorCode['Operation failed!']`),
  11231040: () => $t(`errorCode['The selected duration cannot be more than one year.']`),
  11231041: () => $t(`errorCode['Operation failed!']`),
  11231042: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11231043: () => $t(`errorCode['Please select at least one item.']`),
  11231044: () =>
    $t(`errorCode['The amount of exported data is too large. Please export it in batches.']`),
  11231045: () => $t(`errorCode['Operation failed!']`),
  11231046: () => $t(`errorCode['Operation failed!']`),
  11231047: () => $t(`errorCode['Operation failed!']`),
  11231048: () => $t(`errorCode['Failed to get data.']`),
  11231049: () => $t(`errorCode['Operation failed!']`),
  11231050: () => $t(`errorCode['Operation failed!']`),
  11231051: () => $t(`errorCode['Operation failed!']`),
  11231052: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11231053: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['personnel']`)]),
  11231054: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['recheck in time']`)]),
  11231055: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['recheck out time']`)]),
  11231056: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['recheck in time']`)]),
  11231057: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['recheck out time']`)]),
  11231058: () => $t(`errorCode['']`),
  11231060: () => $t(`errorCode['Operation failed!']`),
  11231062: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['security relay']`)]),
  11231064: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Time']`)]),
  11120002: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['The building name']`)]),
  11120006: () => $t(`errorCode['Failed to get data.']`),
  11120008: () => $t(`errorCode['Please delete devices under this building.']`),
  11120010: () => $t(`errorCode['Operation failed!']`),
  11031002: () => $t(`errorCode['Office is required.']`),
  11031003: () => $t(`errorCode['Failed to get data.']`),
  11031006: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Company name']`)]),
  11031007: () => $t(`errorCode['Company is required.']`),
  11031008: () => $t(`errorCode['Operation failed!']`),
  11031009: () => $t(`errorCode['Operation failed!']`),
  11031010: () => $t(`errorCode['Device is required.']`),
  11031011: () => $t(`errorCode['Operation failed!']`),
  11031013: () => $t(`errorCode['Operation failed!']`),
  11031014: () => $t(`errorCode['Operation failed!']`),
  11031015: () => $t(`errorCode['Operation failed!']`),
  11031016: () => $t(`errorCode['Operation failed!']`),
  11031017: () => $t(`errorCode['Operation failed!']`),
  11031018: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Floor']`)]),
  11031019: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Accessible Floors']`)]),
  11031021: () => $t(`errorCode['Operation failed!']`),
  11031022: () => $t(`errorCode['Building is required.']`),
  11161002: () => $t(`errorCode['Operation failed!']`),
  11161004: () => $t(`errorCode['Failed to get data.']`),
  11161005: () => $t(`errorCode['Operation failed!']`),
  11161006: () => $t(`errorCode['Operation failed!']`),
  11161007: () => $t(`errorCode['Operation failed!']`),
  11161008: () => $t(`errorCode['Operation failed!']`),
  11161009: () => $t(`errorCode['Operation failed!']`),
  11161010: () => $t(`errorCode['Failed to get data.']`),
  11161012: () => $t(`errorCode['PIN or RF Card is required.']`),
  11161013: () => $t(`errorCode['Access Group is required.']`),
  11161014: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11161015: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Delivery name']`)]),
  11161016: () => $t(`errorCode['Operation failed!']`),
  11070013: () => $t(`errorCode['Operation failed!']`),
  11070014: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Mac']`)]),
  11070015: () => $t(`errorCode['Operation failed!']`),
  11070016: () => $t(`errorCode['Operation failed!']`),
  11070017: () => $t(`errorCode['Operation failed!']`),
  11070018: () => $t(`errorCode['Operation failed!']`),
  11070019: () => $t(`errorCode['Operation failed!']`),
  11070020: () => $t(`errorCode['Operation failed!']`),
  11070021: () => $t(`errorCode['Operation failed!']`),
  11070025: () => $t(`errorCode['Failed to get data.']`),
  11070026: () => $t(`errorCode['Operation failed!']`),
  11070038: () => $t(`errorCode['Operation failed!']`),
  11070040: () => $t(`errorCode['Operation failed!']`),
  11070041: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['MAC']`)]),
  11070043: () => $t(`errorCode['Failed to get data.']`),
  11070047: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Address']`)]),
  11070048: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Address']`)]),
  11070049: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Timeout']`)]),
  11070052: () => $t(`errorCode['Failed to get data.']`),
  11070053: () => $t(`errorCode['Operation failed!']`),
  11070054: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Controlled Relay']`)]),
  11070055: () =>
    $t(`errorCode['Invalid {0}.']`, [
      $t(`errorCode['selection, The same reader cannot be set for both entry and exit']`)
    ]),
  11070056: () => $t(`errorCode['Operation failed!']`),
  11070057: () => $t(`errorCode['Failed to get data.']`),
  11070058: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Door number']`)]),
  11070061: () => $t(`errorCode['door input cannot be selection duplicated.']`),
  11070063: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Assign']`)]),
  11070064: () => $t(`errorCode['When lockdown is on, the controlled relay cannot be modified.']`),
  11070066: () => $t(`errorCode['You cannot select Relay and Door at the same time']`),
  11070067: () =>
    $t(`errorCode['A reader cannot be configured to use both Wiegand and RS485 simultaneously.']`),
  11041002: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Group name']`)]),
  11041003: () => $t(`errorCode['Operation failed!']`),
  11041004: () => $t(`errorCode['Operation failed!']`),
  11041005: () => $t(`errorCode['Operation failed!']`),
  11041006: () => $t(`errorCode['Failed to get data.']`),
  11041009: () => $t(`errorCode['Group is required.']`),
  11041011: () => $t(`errorCode['Company is required.']`),
  11041012: () => $t(`errorCode['Office is required.']`),
  11041013: () => $t(`errorCode['Operation failed!']`),
  11041014: () => $t(`errorCode['Operation failed!']`),
  11041015: () => $t(`errorCode['Operation failed!']`),
  11041016: () => $t(`errorCode['Operation failed!']`),
  11041017: () => $t(`errorCode['Operation failed!']`),
  11041018: () => $t(`errorCode['Operation failed!']`),
  11041019: () => $t(`errorCode['Operation failed!']`),
  11041020: () => $t(`errorCode['Operation failed!']`),
  11041021: () => $t(`errorCode['Operation failed!']`),
  11041022: () => $t(`errorCode['Operation failed!']`),
  11041023: () => $t(`errorCode['Operation failed!']`),
  11041024: () => $t(`errorCode['Operation failed!']`),
  11041025: () => $t(`errorCode['Operation failed!']`),
  11150001: () => $t(`errorCode['Operation failed!']`),
  11150002: () => $t(`errorCode['Operation failed!']`),
  11150003: () => $t(`errorCode['Company is required.']`),
  11150004: () => $t(`errorCode['Operation failed!']`),
  11150007: () => $t(`errorCode['Operation failed!']`),
  11150008: () => $t(`errorCode['Operation failed!']`),
  11150009: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11150010: () => $t(`errorCode['Operation failed!']`),
  11150011: () => $t(`errorCode['Operation failed!']`),
  11150014: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11150015: () => $t(`errorCode['Operation failed!']`),
  11150016: () => $t(`errorCode['Failed to get data.']`),
  11150017: () => $t(`errorCode['Operation failed!']`),
  11150022: () => $t(`errorCode['The end time cannot be earlier than the start time.']`),
  11061003: () => $t(`errorCode['Failed to get data.']`),
  11061004: () => $t(`errorCode['Operation failed!']`),
  11061005: () => $t(`errorCode['Title can contain up to 32 characters.']`),
  11061006: () => $t(`errorCode['Content can contain up to 1024 characters.']`),
  11061007: () => $t(`errorCode['Content can contain up to 64 characters.']`),
  11061008: () => $t(`errorCode['Failed to get data.']`),
  11061009: () => $t(`errorCode['Failed to get data.']`),
  11061010: () => $t(`errorCode['Failed to get data.']`),
  11061011: () => $t(`errorCode['Operation failed!']`),
  11061012: () => $t(`errorCode['Failed to get data.']`),
  11061013: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11061014: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11061015: () => $t(`errorCode['Failed to get data.']`),
  11061016: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11061017: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11061019: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Company']`)]),
  11290002: () => $t(`errorCode['Operation failed!']`),
  11290003: () => $t(`errorCode['Office is required.']`),
  11290004: () => $t(`errorCode['Report is required.']`),
  11290005: () => $t(`errorCode['Failed to get data.']`),
  11290006: () => $t(`errorCode['Failed to get data.']`),
  11290007: () => $t(`errorCode['Operation failed!']`),
  11290008: () => $t(`errorCode['Please set the perimeter door group first.']`),
  11290009: () => $t(`errorCode['Failed to get data.']`),
  11290010: () => $t(`errorCode['Operation failed!']`),
  11291011: () => $t(`errorCode['Operation failed!']`),
  11291017: () => $t(`errorCode['Failed to get data.']`),
  11291019: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11051003: () => $t(`errorCode['Operation failed!']`),
  11051004: () => $t(`errorCode['Group is required.']`),
  11051005: () => $t(`errorCode['Failed to get data.']`),
  11051006: () => $t(`errorCode['Failed to get data.']`),
  11051008: () => $t(`errorCode['Failed to get data.']`),
  11051010: () => $t(`errorCode['Failed to get data.']`),
  11051011: () => $t(`errorCode['Operation failed!']`),
  11051012: () => $t(`errorCode['Failed to get data.']`),
  11051013: () => $t(`errorCode['Failed to get data.']`),
  11051014: () => $t(`errorCode['Failed to get data.']`),
  11051016: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Email']`)]),
  11051017: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Phone number']`)]),
  11051018: () =>
    $t(`errorCode['The ID can contain only digits and letters, up to 32 characters.']`),
  11051019: () =>
    $t(`errorCode['The ID can contain only digits and letters, up to 32 characters.']`),
  11051020: () => $t(`errorCode['Operation failed!']`),
  11051021: () => $t(`errorCode['Operation failed!']`),
  11051023: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['ID']`)]),
  11051024: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Verification Code']`)]),
  11051025: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Verification Code']`)]),
  11051028: () => $t(`errorCode['Password Incorrect.']`),
  11051029: () => $t(`errorCode['ID is required.']`),
  11051030: () => $t(`errorCode['Operation failed!']`),
  11051032: () => $t(`errorCode['Failed to get data.']`),
  11051033: () =>
    $t(`errorCode['Please contact your service provider to activate this advanced feature.']`),
  11051034: () => $t(`errorCode['Failed to get data.']`),
  11051035: () => $t(`errorCode['SIP Account required.']`),
  11051036: () => $t(`errorCode['Operation failed!']`),
  11090001: () => $t(`errorCode['Operation failed!']`),
  11090002: () => $t(`errorCode['Operation failed!']`),
  11090003: () => $t(`errorCode['Operation failed!']`),
  11090004: () => $t(`errorCode['Operation failed!']`),
  11090005: () => $t(`errorCode['Failed to get data.']`),
  11090008: () => $t(`errorCode['Failed to get data.']`),
  11090010: () => $t(`errorCode['Operation failed!']`),
  11090011: () => $t(`errorCode['Operation failed!']`),
  11090012: () => $t(`errorCode['The office does not exist.']`),
  11090013: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['timezone']`)]),
  11090014: () => $t(`errorCode['Operation failed!']`),
  11090015: () => $t(`errorCode['Operation failed!']`),
  11090016: () => $t(`errorCode['Operation failed!']`),
  11090017: () => $t(`errorCode['Failed to get data.']`),
  11090018: () => $t(`errorCode['Failed to get data.']`),
  11090019: () => $t(`errorCode['Failed to get data.']`),
  11090020: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Office name']`)]),
  11090022: () => $t(`errorCode['The office does not exist.']`),
  11090023: () => $t(`errorCode['Operation failed!']`),
  11090024: () => $t(`errorCode['Operation failed!']`),
  11090025: () =>
    $t(`errorCode['You can only import one template at a time in the current site.']`),
  11090026: () =>
    $t(`errorCode['You can only import one template at a time in the current site.']`),
  11090027: () => $t(`errorCode['Operation failed!']`),
  11090029: () => $t(`errorCode['Operation failed!']`),
  11090034: () => $t(`errorCode['Operation failed!']`),
  11090035: () => $t(`errorCode['Operation failed!']`),
  11090036: () => $t(`errorCode['']`),
  11090037: () => $t(`errorCode['']`),
  11090038: () => $t(`errorCode['Operation failed!']`),
  11090039: () => $t(`errorCode['Operation failed!']`),
  11171002: () => $t(`errorCode['Operation failed!']`),
  11171003: () => $t(`errorCode['Operation failed!']`),
  11171004: () => $t(`errorCode['Operation failed!']`),
  11171005: () => $t(`errorCode['Operation failed!']`),
  11171006: () => $t(`errorCode['Failed to get data.']`),
  11171007: () => $t(`errorCode['The Temp Key does not exist.']`),
  11171008: () => $t(`errorCode['Failed to get data.']`),
  11171009: () => $t(`errorCode['Operation failed!']`),
  11171010: () => $t(`errorCode['Failed to get data.']`),
  11171011: () => $t(`errorCode['Failed to get data.']`),
  11171012: () => $t(`errorCode['Operation failed!']`),
  11171013: () => $t(`errorCode['Failed to get data.']`),
  11171014: () => $t(`errorCode['The office does not exist.']`),
  11171015: () => $t(`errorCode['Operation failed!']`),
  11171016: () => $t(`errorCode['Please select a device.']`),
  11171017: () => $t(`errorCode['Operation failed!']`),
  11171018: () => $t(`errorCode['Operation failed!']`),
  11171019: () => $t(`errorCode['The start time cannot be later than the end time.']`),
  11171020: () => $t(`errorCode['Operation failed!']`),
  11171021: () => $t(`errorCode['Failed to get data.']`),
  11171022: () => $t(`errorCode['Operation failed!']`),
  11301000: () => $t(`errorCode['Operation failed!']`),
  11301001: () => $t(`errorCode['Operation failed!']`),
  11301002: () => $t(`errorCode['Operation failed!']`),
  11301003: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['param']`)]),
  11301005: () =>
    $t(
      `errorCode['Please check if there is any unpaid orders, if not, please contact your service provider.']`
    ),
  11301006: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11301007: () => $t(`errorCode['Operation failed!']`),
  11301008: () => $t(`errorCode['Operation failed!']`),
  11301010: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['param']`)]),
  11301011: () => $t(`errorCode['Operation failed!']`),
  11301012: () => $t(`errorCode['Operation failed!']`),
  11301013: () =>
    $t(`errorCode['Please ensure that all doors in the project are activated at the same time.']`),
  11301014: () => $t(`errorCode['Operation failed!']`),
  11301015: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['param']`)]),
  11301016: () => $t(`errorCode['Operation failed!']`),
  11301017: () => $t(`errorCode['Operation failed!']`),
  11301018: () =>
    $t(
      `errorCode['Please check if there is any unpaid orders, if not, please contact your service provider.']`
    ),
  11301019: () =>
    $t(`errorCode['Please ensure that all doors in the project are renewed at the same time.']`),
  11301023: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['charge type']`)]),
  11280002: () => $t(`errorCode['Operation failed!']`),
  11280003: () => $t(`errorCode['Operation failed!']`),
  11280004: () => $t(`errorCode['Operation failed!']`),
  11280005: () => $t(`errorCode['Operation failed!']`),
  11280006: () => $t(`errorCode['Operation failed!']`),
  11280007: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Parking Lot Name']`)]),
  11280008: () => $t(`errorCode['Operation failed!']`),
  11280009: () => $t(`errorCode['Operation failed!']`),
  11280010: () => $t(`errorCode['Operation failed!']`),
  11280012: () => $t(`errorCode['']`),
  11280013: () => $t(`errorCode['Operation failed!']`),
  11280014: () => $t(`errorCode['Operation failed!']`),
  11280015: () => $t(`errorCode['Failed to get data.']`),
  11280016: () =>
    $t(`errorCode['The amount of exported data is too large. Please export it in batches.']`),
  11280017: () => $t(`errorCode['Operation failed!']`),
  11280018: () => $t(`errorCode['Operation failed!']`),
  11280019: () => $t(`errorCode['Operation failed!']`),
  11280020: () => $t(`errorCode['Operation failed!']`),
  11280021: () => $t(`errorCode['Operation failed!']`),
  11280022: () => $t(`errorCode['Operation failed!']`),
  11280023: () => $t(`errorCode['Operation failed!']`),
  11201002: () => $t(`errorCode['Operation failed!']`),
  11201003: () =>
    $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['identity information! Please login again']`)]),
  11201009: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11201010: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11201011: () => $t(`errorCode['Operation failed!']`),
  11201015: () => $t(`errorCode['Operation failed!']`),
  11201016: () => $t(`errorCode['Operation failed!']`),
  11201017: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11201018: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11201021: () => $t(`errorCode['Operation failed!']`),
  11201023: () =>
    $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['identity information! Please login again']`)]),
  11211001: () => $t(`errorCode['Operation failed!']`),
  11211002: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Pin Code']`)]),
  11211003: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Lock Name']`)]),
  11211004: () => $t(`errorCode['Operation failed!']`),
  11211005: () => $t(`errorCode['Failed to get data.']`),
  11211007: () => $t(`errorCode['Operation failed!']`),
  11211008: () => $t(`errorCode['Operation failed!']`),
  11211009: () => $t(`errorCode['Failed to get data.']`),
  11211010: () => $t(`errorCode['Operation failed!']`),
  11211011: () => $t(`errorCode['Failed to get data.']`),
  11211012: () => $t(`errorCode['Failed to get data.']`),
  11211013: () => $t(`errorCode['Operation failed!']`),
  11211014: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Name']`)]),
  11211015: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Code']`)]),
  11211016: () => $t(`errorCode['Operation failed!']`),
  11211017: () => $t(`errorCode['Operation failed!']`),
  11211018: () => $t(`errorCode['Operation failed!']`),
  11211019: () => $t(`errorCode['Same account cannot login in different ins.']`),
  11211020: () => $t(`errorCode['Operation failed!']`),
  11211021: () => $t(`errorCode['Operation failed!']`),
  11211022: () => $t(`errorCode['Operation failed!']`),
  11211023: () => $t(`errorCode['Operation failed!']`),
  11321000: () => $t(`errorCode['invalid client id or secret']`),
  11321001: () => $t(`errorCode['invalid account or password']`),
  11321002: () => $t(`errorCode['invalid access token']`),
  11321003: () => $t(`errorCode['invalid refresh token']`),
  11321004: () => $t(`errorCode['no permission to access this project']`),
  11321005: () => $t(`errorCode['timestamp must be within 3 minutes of current server time']`),
  11321015: () => $t(`errorCode["user don\'t active"]`),
  11321016: () => $t(`errorCode['User has expired']`),
  11321017: () => $t(`errorCode['project is not valid']`),
  11321018: () => $t(`errorCode['timestamp must be within 3 minutes of current server time']`),
  11321019: () =>
    $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['identity information! Please login again']`)]),
  11321020: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11111002: () => $t(`errorCode['Operation failed!']`),
  11111003: () => $t(`errorCode['Operation failed!']`),
  11111004: () => $t(`errorCode['Operation failed!']`),
  11111005: () => $t(`errorCode['Operation failed!']`),
  11221001: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['relay']`)]),
  11221002: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['autolock time']`)]),
  11221003: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Pin Code']`)]),
  11221008: () => $t(`errorCode['Failed to get data.']`),
  11221010: () => $t(`errorCode['Failed to get data.']`),
  11221011: () => $t(`errorCode['This lock has already been added to another apartment.']`),
  11221012: () => $t(`errorCode['This lock has already been added to the apartment.']`),
  11221017: () => $t(`errorCode['Failed to get data.']`),
  11221020: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['User']`)]),
  11221021: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Device UUID']`)]),
  11221023: () =>
    $t(
      `errorCode['You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.']`
    ),
  11221024: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Model']`)]),
  11221025: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Language']`)]),
  11221026: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Stay Alarm Time']`)]),
  11221027: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Monitoring Scope']`)]),
  11221028: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Volume']`)]),
  11221029: () => $t(`errorCode['This function only support sl20 lock.']`),
  11221030: () => $t(`errorCode['Json marshal error.']`),
  11221031: () => $t(`errorCode['Json unmarshal error.']`),
  11221032: () => $t(`errorCode['Illegal request, not added within valid time.']`),
  11221033: () => $t(`errorCode['cannot find community PrivateKey.']`),
  11221034: () => $t(`errorCode['cannot find single PrivateKey.']`),
  11221035: () => $t(`errorCode['cannot find single rf Card.']`),
  11221036: () => $t(`errorCode['cannot find community rf Card.']`),
  11221037: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['smartLock model']`)]),
  11021003: () => $t(`errorCode['Operation failed!']`),
  11021004: () => $t(`errorCode['Operation failed!']`),
  11021005: () => $t(`errorCode['Operation failed!']`),
  11021014: () => $t(`errorCode['Operation failed!']`),
  11021015: () => $t(`errorCode['Operation failed!']`),
  11021016: () => $t(`errorCode['Operation failed!']`),
  11021017: () => $t(`errorCode['Operation failed!']`),
  11021018: () => $t(`errorCode['Operation failed!']`),
  11021019: () => $t(`errorCode['Operation failed!']`),
  11021020: () => $t(`errorCode['Operation failed!']`),
  11021021: () => $t(`errorCode['Operation failed!']`),
  11021022: () => $t(`errorCode['Operation failed!']`),
  11021023: () => $t(`errorCode['The User does not exist.']`),
  11021024: () => $t(`errorCode['The Installer does not exist.']`),
  11021025: () => $t(`errorCode['The Project does not exist.']`),
  11021026: () => $t(`errorCode['The Distributor does not exist.']`),
  11021027: () => $t(`errorCode['The Community Device does not exist.']`),
  11021028: () => $t(`errorCode['Operation failed!']`),
  11021029: () => $t(`errorCode['Operation failed!']`),
  11021030: () => $t(`errorCode['Failed to get data.']`),
  11021031: () => $t(`errorCode['Failed to get data.']`),
  11021032: () => $t(`errorCode['The Property Manager does not exist.']`),
  11021034: () => $t(`errorCode['The Sub Distributor does not exist.']`),
  11021035: () => $t(`errorCode['Failed to get data.']`),
  11021036: () => $t(`errorCode['The Single Slave does not exist.']`),
  11021037: () => $t(`errorCode['The Property Manager EndUser does not exist.']`),
  11021038: () => $t(`errorCode['The Family Member does not exist.']`),
  11021039: () => $t(`errorCode['The Sub Distributor does not exist.']`),
  11021041: () => $t(`errorCode['']`),
  11021042: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['smart lock device']`)]),
  11021043: () => $t(`errorCode['The third party not exist.']`),
  11021044: () => $t(`errorCode['Create HW SN Config Empty SN.']`),
  11021045: () => $t(`errorCode['the project does not open smart home']`),
  11021046: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['The SN']`)]),
  11021047: () => $t(`errorCode['SN can contain up to 32 characters.']`),
  11021048: () => $t(`errorCode['Check HW SN Not Found.']`),
  11021049: () => $t(`errorCode['the end user not found']`),
  11021050: () => $t(`errorCode['php web server error']`),
  11021051: () => $t(`errorCode['Ins not found.']`),
  11021052: () => $t(`errorCode['RentManage Unit Not Set.']`),
  11021053: () => $t(`errorCode['Create HW SN Config Empty SN.']`),
  11021054: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['The SN']`)]),
  11021055: () => $t(`errorCode['SN can contain up to 32 characters.']`),
  11021056: () => $t(`errorCode['Check HW SN Not Found.']`),
  11021057: () => $t(`errorCode['the end user not found']`),
  11021058: () => $t(`errorCode['add audit log error']`),
  11021060: () => $t(`errorCode['check building in error']`),
  11021061: () => $t(`errorCode['Special devices cannot be deleted']`),
  11330002: () => $t(`errorCode['invalid nvr type']`),
  11330003: () => $t(`errorCode['project is empty']`),
  11330004: () => $t(`errorCode['project type is invalid']`),
  11330005: () => $t(`errorCode['owner is invalid']`),
  11330006: () => $t(`errorCode['url is invalid']`),
  11330007: () => $t(`errorCode['password is invalid']`),
  11330008: () => $t(`errorCode['building is invalid']`),
  11330009: () => $t(`errorCode['fail to get data']`),
  11271001: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11271002: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Param']`)]),
  11271004: () => $t(`errorCode['Account already linked to another user.']`),
  11271005: () => $t(`errorCode['Failed to get data.']`),
  11271006: () => $t(`errorCode['Operation failed!']`),
  11271007: () => $t(`errorCode['Operation failed!']`),
  11391010: () => $t(`errorCode['the email is empty']`),
  11391011: () => $t(`errorCode['the email format is incorrect']`),
  11391012: () => $t(`errorCode['the mobile number is empty']`),
  11391013: () => $t(`errorCode['the mobile number format is incorrect']`),
  11391014: () => $t(`errorCode['Site not found']`),
  11391015: () => $t(`errorCode['User not found']`),
  11081003: () => $t(`errorCode['Failed to get data.']`),
  11081004: () => $t(`errorCode['Operation failed!']`),
  11081005: () => $t(`errorCode['Failed to get data.']`),
  11081006: () => $t(`errorCode['Operation failed!']`),
  11081010: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Verification Code']`)]),
  11081016: () => $t(`errorCode['Password Incorrect.']`),
  11081021: () => $t(`errorCode['Please try again 24 hours later.']`),
  11081023: () => $t(`errorCode['You are trying too often, please try again in 5 minutes.']`),
  11081024: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Code']`)]),
  11081025: () => $t(`errorCode['You are trying too often, please try again in 5 minutes.']`),
  11241002: () => $t(`errorCode['Operation failed!']`),
  11241003: () => $t(`errorCode['Operation failed!']`),
  11241004: () => $t(`errorCode['Operation failed!']`),
  11241005: () => $t(`errorCode['Operation failed!']`),
  11241007: () => $t(`errorCode['Operation failed!']`),
  11241008: () => $t(`errorCode['Operation failed!']`),
  11241009: () => $t(`errorCode['invalid allow pm view type']`),
  11241010: () => $t(`errorCode['invalid time format']`)
};
export default errorCodeMap;
